import React from 'react';
import ProductInterface from '../ProductInterface';
import GridmapOptions from './GridmapOptions';
import { processGridmap } from './gridmapProcess';

export default function Gridmap() {
  return (
      <ProductInterface
          product = "gridmap"
          ProductOptions = {GridmapOptions}
          processProduct = {processGridmap}
      />
  )
} 